import React, { Component } from 'react'
import Select from 'react-select'

class Categories extends Component {
    constructor() {
        super()
        this.state = {
            CategoriesList:[ {"label":"Permanent","value":"Permanent"},{"label":"Bench","value":"Bench"},{"label":"Consultant","value":"Consultant"},{"label":"Intern","value":"Intern"},{"label":"Part-Time","value":"Part-Time"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.CategoriesList}
                placeholder="Select Category"
                onChange={(e) => { (e) ? this.props.categoryChange(e) : this.props.categoryChange([])}}
                />
            </div>
        )
    }
}

export default Categories


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/Categories.js